import { IconProps } from './Icon';

export const PosOutlineIcon = ({
  width,
  height,
  className,
  color,
}: IconProps) => (
  <svg
    className={className}
    color={color}
    fill={color}
    height={height}
    viewBox="0 0 32 32"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Layer">
      <path d="M24,2H8A3,3,0,0,0,5,5V27.42A2.39,2.39,0,0,0,9.28,28.9l.8-1,1.5,1.52a2,2,0,0,0,2.84,0L16,27.8l1.58,1.6a2,2,0,0,0,2.84,0l1.5-1.52.8,1A2.39,2.39,0,0,0,27,27.42V5A3,3,0,0,0,24,2Zm1,25.42a.4.4,0,0,1-.71.25l-1.5-1.92a1.05,1.05,0,0,0-.73-.38,1,1,0,0,0-.77.3L19,28l-2.3-2.33a1,1,0,0,0-1.42,0L13,28l-2.3-2.33a1,1,0,0,0-.77-.3,1.05,1.05,0,0,0-.73.38l-1.5,1.92a.39.39,0,0,1-.44.13A.39.39,0,0,1,7,27.42V5A1,1,0,0,1,8,4H24a1,1,0,0,1,1,1ZM17,18a1,1,0,0,1-1,1H10a1,1,0,0,1,0-2h6A1,1,0,0,1,17,18Zm6-5a1,1,0,0,1-1,1H10a1,1,0,0,1,0-2H22A1,1,0,0,1,23,13Zm0-5a1,1,0,0,1-1,1H10a1,1,0,0,1,0-2H22A1,1,0,0,1,23,8Z" />
    </g>
  </svg>
);
